import slice from "./modals.slice";

const { showModal, setModalDisabled } = slice.actions;

export { showModal, setModalDisabled };
